module.exports = __webpack_public_path__ + "img/root101.470700a8.png";